import React from 'react';
export function ResourcesClosingCta() {
  return <section className="w-full bg-brand-navy py-12 md:py-14 px-4 sm:px-6 lg:px-8 text-center" data-id="element-146" data-mp="3168lvmdx1nuw">
      <div className="max-w-4xl mx-auto" data-id="element-147" data-mp="2lyh98eyytrp5">
        <h2 className="text-4xl md:text-5xl lg:text-6xl font-bold text-white mb-8 leading-tight" data-id="element-148" data-mp="2h061qaw57ta3">
          Want to go deeper?
        </h2>
        <p className="text-xl md:text-2xl text-gray-300 mb-12 leading-relaxed max-w-3xl mx-auto" data-id="element-149" data-mp="2c35vnzzamqiz">
          If something you've read or watched resonates and you want to talk
          about how it applies to your team, I'm always up for a conversation.
        </p>
        <div className="flex flex-col items-center space-y-6" data-id="element-150" data-mp="2zqe0yhwq1zl0">
          <a href="#/contact/book" className="inline-flex items-center justify-center px-8 py-4 border border-transparent text-lg font-bold rounded bg-brand-orange text-white hover:bg-brand-orange-hover transition-colors shadow-sm w-full sm:w-auto" data-id="element-151" data-mp="2zt09okvcml4t">
            Book a Call
          </a>
          <p className="text-white text-base" data-id="element-152" data-mp="11i9xfzq0na7s">
            Or email me directly:{' '}
            <a href="mailto:michael@breakapencil.com" className="text-white border-b-2 border-brand-orange hover:text-brand-orange transition-colors pb-0.5" data-id="element-153" data-mp="16h371h26mh2o">
              michael@breakapencil.com
            </a>
          </p>
        </div>
      </div>
    </section>;
}